import {decrementLoadingCounter, incrementLoadingCounter, resetLoadingCounter} from './loadingActions'
import {Constants} from './loadingConstants'

type Actions =
    | ReturnType<typeof incrementLoadingCounter>
    | ReturnType<typeof decrementLoadingCounter>
    | ReturnType<typeof resetLoadingCounter>

export function loadingReducer(
	state = 0,
	action: Actions
) {
	switch (action.type) {
	case Constants.INCREMENT_LOADING_COUNTER:
		state = state ++
		break
	case Constants.DECREMENT_LOADING_COUNTER:
		state = state --
		break
	case Constants.RESET_COUNTER:
		state = 0

	}
	return state
}

